export default __webpack_public_path__ + "static/media/soundcloud-bw.993dab0b.svg";